export const normaliseLookupDomain = (value: string): string => {
	const trimmed = value.trim().toLowerCase();
	const afterAt = trimmed.slice(trimmed.lastIndexOf('@') + 1);

	return afterAt;
};
